import React, {useEffect} from 'react';
import bg from "../../assets/fix-Q6TBVY8X.jpg";
import Form from "../Form";
import {useAbout, useEmployee, useGetAbout, useGetEmployeeById} from "../stores/otherStore";
import { Phone, MessageCircle, Star } from "lucide-react";
import {useParams} from "react-router-dom";
import Seo from "../utils/Seo";

const CompanyDetail = () => {
    const { id } = useParams();
    const employee = useEmployee();
    const getEmployeeById = useGetEmployeeById();

    useEffect(() => {
        if (id) {
            void getEmployeeById(Number(id));
        }
    }, [id, getEmployeeById]);
    useEffect(() => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    }, []);

    if (!employee) {
        return <div className={'h-[70vh]'}>Загрузка...</div>;
    }
    const paragraphs = employee.about_specialist.split(/\r?\n/);
    return (
        <>
            <Seo
                title={`${employee.first_name} ${employee.last_name} — ${employee.position} | Aluu Satuu`}
                description={`${employee.first_name} ${employee.last_name} — ${employee.position} в агентстве недвижимости Aluu Satuu. ${employee.about_specialist.substring(0, 150)}... Связаться: ${employee.phone_number}`}
                url={typeof window !== 'undefined' ? window.location.href : ''}
                image={employee.photo}
                type="profile"
            />
        <div className={'bg-gray-100'}>
            <div className="container py-10 md:px-20 px-5">
                <h2 className={'text-center text-2xl md:text-4xl text-[#39A6E4]'}>СПЕЦИАЛИСТЫ</h2>
                <p className={'md:text-lg mx-4 text-[#777]'}>Мы собрали в одном месте лучших экспертов рынка, чтобы предложить вам лучшее – профессиональные рекомендации и самые выгодные предложения по продаже и покупке недвижимости! Агентство недвижимости «Ayar Group» - ваш эксперт и надежный партнер!</p>
            </div>
            <div className="max-w-5xl mx-auto p-5 md:p-8">
                <div className="flex flex-col md:flex-row gap-8">
                    {/* Фото */}
                    <div className="w-full md:w-1/2">
                        <img
                            src={employee.photo}
                            alt={`${employee.first_name} ${employee.last_name} — ${employee.position} агентства недвижимости Aluu Satuu`}
                            className="w-full h-80 md:h-full object-cover rounded-2xl shadow-lg"
                            loading="lazy"
                        />
                    </div>

                    {/* Инфо */}
                    <div className="flex-1 flex flex-col justify-center gap-4">
                        <h1 className="text-2xl md:text-4xl font-bold text-gray-800">
                            {employee.first_name} {employee.last_name}
                        </h1>
                        <p className="text-lg md:text-xl text-gray-600">
                            {employee.position}
                        </p>

                        <div>
                            <h2 className="text-xl font-semibold text-gray-800 mb-2">
                                О специалисте
                            </h2>
                            {paragraphs.map((para, i) => (
                                <p key={i} className='mt-0.5 text-[#212529]'>{para.trim()}</p>
                            ))}
                        </div>

                        <p className="text-md md:text-lg text-gray-700">
                            ☎ {employee.phone_number}
                        </p>
                        <a
                            href={employee.whatsapp}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-green-500 text-white hover:bg-green-600 transition w-full md:w-auto"
                        >
                            <MessageCircle size={20} /> Написать в WhatsApp
                        </a>
                    </div>
                </div>
            </div>
            {/*<div*/}
            {/*    className="px-2 relative text-white h-[50vh] w-full bg-center bg-no-repeat bg-cover"*/}
            {/*    style={{ backgroundImage: `url(${bg})` }}*/}
            {/*>*/}
            {/*    <div className="absolute inset-0 bg-black/60"></div>*/}
            {/*    <div className="relative container z-10 w-full h-full px-4 flex flex-col items-center justify-center">*/}
            {/*        <div className="w-full md:w-2/3 md:p-6 p-3 rounded-lg shadow-md bg-[rgba(255, 255, 255, .15)] backdrop-blur mt-5">*/}
            {/*            <h3 className="md:text-xl text-center text-white">Для бесплатной консультации оставьте свои контакты</h3>*/}
            {/*            <Form/>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </div>
        </>
    );
};

export default CompanyDetail;